import * as React from 'react';
import clsx from 'clsx';
import themePrimary from '../../styles/themePrimary';
import { makeStyles, StepIconProps } from '@material-ui/core';
import CPCheckImage from '../../images/cp_check.png'
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { Skin } from '../../models/common/Skin';

const useStyles = makeStyles({
    active: {
        color: props => (props as Skin).primary_main_color + ' !important',
    },
    circle: {
        width: 20,
        height: 20,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
    completed: {
        zIndex: 1,
        height: '22px',
    },
    root: {
        color: '#828282',
        display: 'flex',
        height: 22,
        alignItems: 'center',
      },
});

export default function CustomStepIcon(props: StepIconProps) {
    const { active, completed } = props;
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
        })}
      >
        {completed ? <img src={CPCheckImage} className={classes.completed}/> : <div className={classes.circle} />}
      </div>
    );
};